import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'searchReportAttributesPipe'
})
export class SearchReportAttributesPipe implements PipeTransform {
	transform(items: any[], searchText: string): any[] {
		if (!items) {
			return [];
		}
		if (!searchText) {
			return items;
		}
		searchText = searchText.toLowerCase().trim();
		const filteredArray = items.filter((arrayObject) => {
			return arrayObject.friendlyName.toString().toLowerCase().indexOf(searchText) !== -1;
		});
		return filteredArray;
	}
}
